<template>
  <div class=" is-fullwidth">
    <div class="  ">
        <div class="columns ">
          <div class="column">
            <button class="button is-light" @click="toggleShowAllOrders">
              {{ show_all ? 'Show Only Cut/Sew' : 'Show All Orders' }}
            </button>
          </div>
          <div class="column is-one-fifth">
            <button class="button is-light">{{filteredOrders.length}} orders / {{ this.totalGarments}} garments</button>
          </div>
          <div class="column is-one-fifth">
        <input class="input " v-model="search" placeholder="search orders ..."/>
          </div>
          
           
          </div>
          <br />
    </div>

    <div class="notification is-primary" v-if="loading == true">
                Loading orders ...
            </div>
    
            <div class="notification is-warning" v-if="loading == false && filteredOrders.length == 0">
                There are no orders to show
            </div>
   
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" v-if="loading == false && filteredOrders.length > 0">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th>Names</th>
          <th>Initials</th>
          <th>Numbering</th>
          <th @click="updateSortOrder('orderdate')" style="cursor:pointer">Ordered
            <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
            <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Qty</th>
          <th>Makeup</th>
          <th style="display:none">Process</th>
          <th >Personalisation</th>
    	</thead>
    	<tbody>
		    
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
         <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
               <td ><a :href="'/orders/order-search?ponumber=' + order.ponumber" target="_blank">{{order.ponumber}}</a></td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td v-if="order.requires_name == true">
              <span class="tag is-success" v-if="order.names_type == 'Sublimated Print'">{{ order.names_type }}</span>
              <span class="tag is-link" v-if="order.names_type == 'DTF'">{{ order.names_type }}</span>
              <span class="tag is-warning" v-if="order.names_type == 'Embroidery'">{{ order.names_type }}</span>
              <span class="tag is-danger" v-if="order.names_type == 'Not Applicable' || order.names_type == '' || order.names_type == null">Not Chosen</span>
          </td>
          <td v-if="order.requires_name == false">
              <span class="tag is-light">Not Applicable</span>
          </td>
          <td v-if="order.requires_initials == true">
              <span class="tag is-success" v-if="order.initials_type == 'Sublimated Print'">{{ order.initials_type }}</span>
              <span class="tag is-link" v-if="order.initials_type == 'DTF'">{{ order.initials_type }}</span>
              <span class="tag is-warning" v-if="order.initials_type == 'Embroidery'">{{ order.initials_type }}</span>
              <span class="tag is-danger" v-if="order.initials_type == 'Not Applicable' || order.initials_type == '' || order.initials_type == null">Not Chosen</span>
          </td>
          <td v-if="order.requires_initials == false">
              <span class="tag is-light">Not Applicable</span>
          </td>
          <td v-if="order.requires_number == true">
              <span class="tag is-success" v-if="order.numbering_type == 'Sublimated Print'">{{ order.numbering_type }}</span>
              <span class="tag is-link" v-if="order.numbering_type == 'DTF'">{{ order.numbering_type }}</span>
              <span class="tag is-warning" v-if="order.numbering_type == 'Embroidery'">{{ order.numbering_type }}</span>
              <span class="tag is-danger" v-if="order.numbering_type == 'Not Applicable' || order.numbering_type == '' || order.numbering_type == null">Not Chosen</span>
          </td>
          <td v-if="order.requires_number == false">
              <span class="tag is-light">Not Applicable</span>
          </td>
          <td>{{order.orderdate}}</td> 
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
          <td>
            <span v-if="order.ireland==1">Ireland / {{ order.makeup_location_name }}</span>
            <span v-if="order.offshore==1">Offshore / {{  order.makeup_location_name }}</span>
          </td>

          <!-- New orders view-->
          <td  style="display:none">
            <div class="buttons">
              <button class="button is-small "  @click="setInProgress(order)" :disabled="working==true">Process</button>
            </div>
          </td>
          <td>
            <button class="is-small button is-success" @click="openOrderModal(order)">Open</button>
          </td>

              
			</tr>
    	</tbody>
    </table>

    <div class="modal" :class="{ 'is-active': showOrderModal }">
      <div class="modal-background" @click="closeOrderModal"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title" v-if="selectedOrder">{{ selectedOrder.ponumber }}</p>
          <button class="delete" aria-label="close" @click="closeOrderModal"></button>
        </header>
        <section class="modal-card-body" v-if="selectedOrder">
          <table class="table is-fullwidth is-striped is-size-7" id="ordersTable">
            <thead>
              <th>Size</th>
              <th>Initials (<span style="cursor:pointer" @click="copyInitials">Copy</span>)</th>
              <th>Name</th>
              <th>Number</th>
            </thead>
            <tbody>
              <template v-if="selectedOrder.order_numbering && selectedOrder.order_numbering.length">
                <tr v-for="(item, index) in selectedOrder.order_numbering" :key="index">
                  <td>{{ item.print_name }}</td>
                  <td>{{ item.initials }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.number }}</td>
                </tr>
              </template>
              <tr v-if="!selectedOrder.order_numbering || !selectedOrder.order_numbering.length">
                <td colspan="4">No personalisation rows found for this order.</td>
              </tr>
            </tbody>

          </table>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="closeOrderModal">Close</button>
        </footer>
      </div>
    </div>


    
    
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
    
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showDespatchModal: false,
      selectedOrder: null,
      showOrderModal: false,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      show_all: true,
      makeup_location_id: '',
      showAddButtons: true,
      accessToken: '',
      
      search:'',
      tabToView: 'new',
      user: {tasks: []},
      
    }
  },
   methods: {
    capitalize(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
     
    
    
    setInProgress(order)
    {
      this.working = true

        var formdata = { 
          _method: 'patch',
             status: "INPROGRESS"
             
        }; 

        OrderService.updateOrder(this.accessToken, order.orderID, formdata)
        .then(() => {
            order.status = "INPROGRESS"
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
      
    },
    openOrderModal(order) {
      this.selectedOrder = order;
      this.showOrderModal = true;
    },
    closeOrderModal() {
      this.showOrderModal = false;
      this.selectedOrder = null;
    },
    copyInitials() {
      const numbering = (this.selectedOrder && this.selectedOrder.order_numbering) || [];
      const textToCopy = numbering
        .map((item) => (item && item.initials ? String(item.initials).trim() : ''))
        .filter((value) => value !== '')
        .join('\n');

      if (!textToCopy) {
        alert('No initials available to copy.');
        return;
      }

      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          alert('Initials copied to clipboard!');
        })
        .catch((err) => {
          console.error('Copy failed:', err);
          alert('Copy failed. Please try again.');
        });
    },
    toggleShowAllOrders() {
      this.show_all = !this.show_all;
      this.getOrders();
    },
      async getOrders() {
        this.loading=true
        this.orders = []
        OrderService.getCutSewPersonalisationOrders(this.accessToken, this.show_all)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      
    
  },
  computed : {
      filteredOrders: function () {
        // let filteredOrders = []
          //let filteredOrders = this.orders
          let filteredOrders =  this.orders

            if(this.search != '' && this.search != null)
            {
              filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()) || row.garmentname.toLowerCase().includes(this.search.toLowerCase()) || row.clientname.toLowerCase().includes(this.search.toLowerCase()))
            }

           //filteredOrders = filteredOrders.filter(row =>  row.status == "APPROVED")

            return filteredOrders
        
      },
      totalGarments() {
        return this.filteredOrders.reduce((sum, order) => sum + (order.total_qty || 0), 0);
      }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getUserProfile();
        });
  },
 
  mounted() {
    /*if (localStorage.production_allocated_makeup_location_id) {
      this.makeup_location_id = localStorage.production_allocated_makeup_location_id;
    }
    else{
      this.makeup_location_id = 5
    }*/
      
  },
  watch: {
   tabToView: function () {
      if(this.tabToView == "new")
      {
        this.getOrders()
      }
    },
  }
}


</script>

